/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import _ from 'lodash';
import {OBJECT_TYPE} from "../common/constants/object-type";
import {getResourceItemTitleResolves} from '../base/default-item-title-view';
import {LibraryCreativeListContextComponent} from './library-creative-list-context.component';
import {CreativeBulkUploadPageComponent} from '../creative/creative-bulk-upload-page.component';
import {LibraryCreativeContextActionsComponent} from './library-creative-context-actions.component';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {LibraryCreativeResource} from '../../components/api/resources/resource/library-creative.resource';
import {stateTitleView} from '../common/directives/html/state-title.component';

const listTemplate = '<adn-library-creative-list-page [list]="list"></adn-library-creative-list-page>';

export function libraryCreativeStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterHelper('library-creatives.library-creative', LibraryCreativeResource, 'app.adv', 'app', listTemplate);
    
        let paramsExtras = {modelId: '', modelName: '', fromLineItem: false};
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            extension: /*@ngInject*/ function() {
              return {
                func: function(ctrl) {
                  ctrl.creativeFields = ['name', {param: 'Layout', label: 'layout'}, {param: '', label: 'URLs'}, {label: 'dimensions', param: 'width'}, 'updateTime', {param: '', label: 'targeting'}];
                  ctrl.creativeType = "LIBRARY_CREATIVE";
                }
              };
            },
            sectionParam: function() {
              return 'creatives';
            }
          },
          views: _.merge({}, {
            'context@app': {
              component: LibraryCreativeListContextComponent,
              bindings: {readOnly: 'listReadOnly'}
            }
          })
        }))
          .state(rh.newPath('bulkupload'), rh.item({
            url: '/bulk-upload',
            resolve: {
              model: function() {
                return null;
              },
              creativeType: function() {
                return 'LIBRARY_CREATIVE';
              }
            },
            views: {
              'content@app': {
                component: CreativeBulkUploadPageComponent,
                bindings: {creativeType: 'creativeType'}
              },
              'title@app': stateTitleView()
            },
            data: {
              title: 'Library Creative Bulk Upload'
            }
          }))
          .state(rh.newItemPath(), rh.newItem(paramsExtras))
          .state(rh.itemPath(), rh.modelCommsItem({
            params: paramsExtras,
            resolve: _.merge({}, getResourceItemTitleResolves('LibraryCreative'), {
              titleVariant: function() {
                return 'library-creative';
              },
              creativeType: function() {
                return OBJECT_TYPE.LibraryCreative;
              },
              lineItemInfo: function() {
                return {};
              },
              libraryCreativeEditRouteKey: function() {
                return 'library-creative-edit';
              },
              routeEditVariant: function() {
                return 'edit';
              },
              libraryCreativeEditInputs: /*@ngInject*/ function(creativeType, lineItemInfo) {
                return {creativeType, lineItemInfo};
              },
              model: /*@ngInject*/ function($stateParams) {
                if ($stateParams.isNew) {
                  return adnRouterHelper.services.resource(LibraryCreativeResource).create({
                    name: "",
                    id: $stateParams.id
                  });
                }
                return adnRouterHelper.services.resource(LibraryCreativeResource).getHydrated($stateParams);
              }
            }),
            views: {
              'content@app': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {
                  item: 'libraryCreativeEditRouteKey',
                  variant: 'routeEditVariant',
                  inputOverrides: 'libraryCreativeEditInputs'
                }
              },
              'context@app': {
                component: LibraryCreativeContextActionsComponent,
                bindings: {model: 'model', modelComms: 'modelComms', isNew: 'isNew', readOnly: 'readOnly'}
              },
              'title@app': rh.getResourceItemTitleView()
            }
          }));
  }, adnRouterHelper);
}
